import { AlertController, Platform } from 'ionic-angular';
import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LoadingController, NavController } from 'ionic-angular';
import { Network } from '@ionic-native/network';
import { StatusBar } from '@ionic-native/status-bar';
import { Subscription } from 'rxjs';
import { ToastController } from 'ionic-angular';

import { AreaLocalProvider } from '../../providers/area-local/area-local';
import { AuthProvider } from '../../providers/auth/auth';
import { BrComDao } from '../../service/BrComDao';
import { BrComService } from '../../service/BrComService';
import { ContatoLocalProvider } from '../../providers/contato-local/contato-local';
import { NavegadorPage } from '../navegador/navegador';

@Component({
  selector: 'page-fonecpf',
  templateUrl: 'fonecpf.html'
})

export class FoneCpfPage {

  private codEmpresa: number; 
  private readonly linkRadioAPRASC = "http://aprasc.org.br/radio";
  private appDomain: string;
  private URLLogotipoEmpresa: string;
  private subscriptionConexao: Subscription;
  public formularioLogin: FormGroup;
  public usuarioExiste: boolean;

  constructor(private brComService: BrComService, 
    private loadingCtrl: LoadingController, 
    private statusBar: StatusBar, 
    private platform: Platform, 
    private brComDAO: BrComDao, 
    private network: Network,
    private formbuilder: FormBuilder, 
    private authProvider: AuthProvider,
    private toastController: ToastController,
    private navController: NavController,
    private alertController: AlertController,
    private contatoLocalProvider: ContatoLocalProvider,
    private areaLocalProvider: AreaLocalProvider,
    ) {

    this.formularioLogin = this.criarFormularioLogin();
    this.URLLogotipoEmpresa = "";
    this.platform.ready().then(
      () => {
        this.statusBar.overlaysWebView(false);
        this.statusBar.backgroundColorByHexString("#00337d");
        this.definirVariaveisEmpresa();
      }
    )
    this.recarregarImagensQuandoConVoltar();

  }

  public criarFormularioLogin(): FormGroup {
    return this.formbuilder.group({
      'cpf':['', Validators.compose([Validators.required, Validators.minLength(14)])]
    });
  }

  ngOnDestroy() {
    this.subscriptionConexao.unsubscribe();
  }

  private async definirVariaveisEmpresa() {
    this.appDomain = this.brComService.readAppDomain();
    this.codEmpresa = await this.brComService.getCodEmpresaApp();
    this.getPlataformasSociaisEmpresaSeNecessario();
  }

  private getPlataformasSociaisEmpresaSeNecessario() {
    const plataformasSociais = this.getPlataformasSociaisEmpresaLocal();
    if (!plataformasSociais && this.isAprasc()) {
      this.getPlataformasSociaisEmpresaServidor();
    }
  }

  private getPlataformasSociaisEmpresaLocal(): any {
    const plataformasSociais = this.brComDAO.getPlataformasSociaisEmpresa(this.codEmpresa);
    return plataformasSociais;
  }

  private async getPlataformasSociaisEmpresaServidor() {
    this.brComService.getUrlRedesSociaisEmpresa(this.codEmpresa);
  }

  public entrar() {
    const cpf = this.removerCaracteresNaoNumericos(this.formularioLogin.get('cpf').value);
    const loading = this.loadingCtrl.create({content: 'Aguarde...'});
    loading.present();
    this.authProvider.login(cpf, "", this.brComService.getIdDevice()).subscribe(
      (dados: any) => {
        if (dados.usuarios) {
          this.armazenarDadosUsuario(dados);
          this.brComService.iniciaTelaAutenticandoUsuariosValidos(dados.usuarios, cpf);
        } else if (dados.temCadastro){
          this.oferecerCadastro(cpf, dados);
        } else {
          this.aparesentarToast("Usuário não encontrado");
        }
      }, error => {
        loading.dismiss();
        this.aparesentarToast(`Erro: ${JSON.stringify(error)}`);
      }, () => {
        loading.dismiss();
      }
    )
   // this.brComService.efetuaLogin("", cpf);
    /*this.usuarioProvider.login(cpf, '').subscribe(
      result => {
        console.log(JSON.stringify(result));
      }
    );*/
  }

  public validarSenha() {
    console.log('');
  }

  private adicionarCampoSenha(): void {
    this.usuarioExiste = true;
    this.formularioLogin.addControl('senha', this.formbuilder.control('', Validators.required))
  }

  private armazenarDadosUsuario(dados: any): void {
    // melhorar a organização do localstorage com definições do usuário/empresa depois da primeira versão
    let usuarios: any; 
    if (Array.isArray(dados.usuarios)) {
      usuarios = dados.usuarios[0];
    } else {
      usuarios = dados.usuarios;
    }
    this.areaLocalProvider.setAreas(usuarios.Areas);
    this.contatoLocalProvider.setContatos(usuarios.Contatos);
    delete usuarios.Areas;
    delete usuarios.Contatos;
    this.brComService.brComDao.gravaGrupo([usuarios]);
  }

  private oferecerCadastro(cpf: string, dados: any): void {
    this.alertController.create({
      title: "Usuário não encontrado. Deseja cadastrar-se?", buttons: [{
        text: "Sim", handler: () => {
         this.abrirPaginaDeCadastro(cpf, dados);
        }
      }, {
        text: "Não",
        role: "cancel"
      }]
    }).present();
  }

  private abrirPaginaDeCadastro(cpf: string, dados: any): void {
    const idDevice = this.brComService.getIdDevice();
    const url = `${dados.urlCadastrese}&cpf=${cpf}&id_app_usuario=${idDevice}`;
    this.navController.push(NavegadorPage, {url: url});
  }

  private aparesentarToast(mensagem: string) {
    this.toastController.create({
      message: mensagem,
      duration: 3000
    }).present();
  }

  public removerCaracteresNaoNumericos (texto: string):string{
    return texto.replace(/\D/g,'');
 }

  public isAprasc():boolean {
    return this.appDomain == "aprasc";
  }

  public getLinkFacebook(): string {
    const plataformasSociais = this.getPlataformasSociaisEmpresaLocal();
    if(plataformasSociais) {
      return plataformasSociais.urlFacebook;
    }
  }

  public getLinkTwitter(): string {
    const plataformasSociais = this.getPlataformasSociaisEmpresaLocal();
    if(plataformasSociais) {
      return plataformasSociais.urlTwitter;
    }
  }

  public getHashImagemLogotipoEmpresa(): string {
    const plataformasSociais = this.getPlataformasSociaisEmpresaLocal();
    if (plataformasSociais) {
      return plataformasSociais.hashLogotipo;
    }
  }

  public getURLSite(): string {
    const plataformasSociais = this.getPlataformasSociaisEmpresaLocal();
    if (plataformasSociais) {
      return plataformasSociais.urlSite;
    }
  }

  public getImagemLogotipo(): string {
    const URLImagem = this.URLLogotipoEmpresa;
    if (URLImagem === "") {
      const hashLogotipo = this.getHashImagemLogotipoEmpresa();
      if (hashLogotipo) {
        this.URLLogotipoEmpresa = this.brComService.obtemUrlLogotipoEmpresa(hashLogotipo);
      }
    }
    return this.URLLogotipoEmpresa 
  }

  public getNomeEmpresa(): string {
    const plataformasSociais = this.getPlataformasSociaisEmpresaLocal();
    if (plataformasSociais) {
      return plataformasSociais.nomeEmpresa;
    }
  }

  public site() {
    this.brComService.abrePaginaNoBrowser(this.getURLSite());
  }

  public radio() {
    this.brComService.abrePaginaNoBrowser(this.linkRadioAPRASC);
  }

  public recarregarImagensQuandoConVoltar () {
    this.subscriptionConexao = this.network.onConnect().subscribe(
      () => {
        const timestamp = new Date().getTime();
        this.URLLogotipoEmpresa = `${this.URLLogotipoEmpresa}?${timestamp}`
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/fonecpf/fonecpf.ts